/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:41
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-09-15 16:32:43
 */
import Tabs from './Tabs';
import { Tabs as AntdTabs } from '@firesoon/antd';
import { TabsDecorator } from './interface';

const { TabPane } = AntdTabs;

Object.assign(Tabs, {
  TabPane,
});

export default Tabs as unknown as TabsDecorator;
